<template>
  <HeadlineComponent>Passwort zurücksetzen</HeadlineComponent>
  <Form class="form-horizontal" @submit="reset" :initialValues="this.form" v-if="this.form">
    <div class="form-group">
      <label for="email">E-Mail</label>
      <BootstrapField name="email" placeholder="max@mustermann.de" rules="required" type="email" />
    </div>
    <div class="form-group">
      <label for="code">Code</label>
      <BootstrapField name="code" rules="required" type="text" />
    </div>
    <div class="form-group">
      <label for="password">Neues Passwort</label>
      <BootstrapField name="password" placeholder="xxxxxx" rules="required|min:6" type="password" />
    </div>
    <div class="form-group">
      <label for="password">Passwort wiederholen</label>
      <BootstrapField name="password2" placeholder="xxxxxx" rules="required|confirmedPassword:@password"
        type="password" />
    </div>
    <div class="form-group">
      <LoadingButton :loading="loading" class="btn-primary">Weiter</LoadingButton>
    </div>
  </Form>
</template>

<script>
import BootstrapField from "../components/BootstrapField.vue";
import { Form } from "vee-validate";
import { mapActions } from "pinia";
import { useAlertsStore } from "../stores/alerts.js";
import userService from "../services/user.service.js";
import router from "../router/index.js";
import LoadingButton from "../components/LoadingButton.vue";
import HeadlineComponent from "../components/HeadlineComponent.vue";
import * as Sentry from '@sentry/vue';

export default {
  name: "ResetPasswordView",
  data() {
    return {
      form: {},
      loading: false,
    }
  },
  components: { LoadingButton, BootstrapField, Form, HeadlineComponent },
  beforeMount() {
    this.form = { code: this.$route.query.code, email: this.$route.query.email }
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: 'add' }),
    async reset(data, actions) {
      this.loading = true;
      data.code = Number(data.code);
      try {
        let response = await userService.resetPassword(data);
        if (response.data.success) {
          this.addAlert('success', response.data.message);
          router.push('/login');
        } else {
          this.addAlert('danger', response.data.message);
        }
      } catch (e) {
        if (e) {
          if (e.response && e.response.status == 404) {
            actions.setFieldError('email', 'Die E-Mailadresse ist nicht bekannt.');
          } else if(e.response && e.response.status == 403) {
            actions.setFieldError('code', 'Der Code ist falsch.');
          } else {
            Sentry.captureException(e);
            this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
            window.scrollTo(0, 0);
          }
        }
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>
form {
  width: 100%;
  max-width: 330px;
  margin: 0 auto;
  padding: 15px;
}

.form-group {
  text-align: center;
}
</style>